/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"

import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"

import {
  マスタ管理メニューコード,
  メニューコード,
} from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

import {
  TTumiorosisakiListGetReq,
  TTumiorosisakiListGetRes,
  T積卸先,
} from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import TextInput from "../../../components/InputWrapper/TextInput"
import TumiorosisakiService from "../../../service/master/tumiorosisaki/tumiorosisakiService"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import dateUtil from "../../../ts/util/dateUtil"
import { RootState } from "../../../globalStore/rootreducer"
import ContentService from "../../../service/content/contentService"
import saveAs from "file-saver"
import CheckInput from "../../../components/InputWrapper/CheckInput"

/**
 * 積卸先マスタ一覧
 * @returns
 */
const MasterTumiorosisakiList = () => {
  const history = useHistory()
  const location = useLocation()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.積卸先マスタ
      )?.読み取り専用フラグ
  )

  //TODO:ページ名称確定必須
  let gridId = "MasterTumiorosisakiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      calculatedFields: {
        最終更新日時: ($: T積卸先) =>
          dateUtil.format($.更新日時, "YYYY/MM/DD HH:mm:ss"),
      },
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    is最新更新順表示: boolean,
    searchCondition?: TTumiorosisakiListGetReq,
    signal?: AbortSignal
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TTumiorosisakiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new TumiorosisakiService().getList(
        {
          ...currentSearchCondition,
          最新更新順表示フラグ: is最新更新順表示,
        },
        signal
      )

      // 検索結果をstateにセット
      setGridData({
        data: createCollectionView(res.data, pageSize),
      })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TTumiorosisakiListGetReq = queryString.parse(location.search)
    set荷主コード(query.荷主コード)
    set荷主名(query.荷主名)
    set積卸先コード(query.積卸先コード)
    set積卸先名(query.積卸先名)
    set住所１(query.住所１)
    set住所２(query.住所２)
    set削除済み包含フラグ(query.削除済み包含フラグ ? 1 : 0)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TTumiorosisakiListGetReq => {
    return {
      荷主コード,
      荷主名,
      積卸先コード,
      積卸先名,
      住所１,
      住所２,
      削除済み包含フラグ: 削除済み包含フラグ === 1,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TTumiorosisakiListGetReq
  ) => {
    return {
      荷主CD: wjCore.isNullOrWhiteSpace(searchCondition.荷主コード ?? "")
        ? ""
        : searchCondition.荷主コード,
      荷主名: wjCore.isNullOrWhiteSpace(searchCondition.荷主名 ?? "")
        ? ""
        : searchCondition.荷主名,
      積卸先CD: searchCondition.積卸先コード,
      積卸先名: searchCondition.積卸先名,
      都道府県: searchCondition.住所１,
      市区町村: searchCondition.住所２,
      削除済み包含フラグ: searchCondition.削除済み包含フラグ,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set荷主コード("")
    set荷主名("")
    set積卸先コード("")
    set積卸先名("")
    set住所１("")
    set住所２("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [積卸先コード, set積卸先コード] = useState<string>()
  const [積卸先名, set積卸先名] = useState<string>()
  const [住所１, set住所１] = useState<string>()
  const [住所２, set住所２] = useState<string>()
  const [削除済み包含フラグ, set削除済み包含フラグ] = useState<number>(0)

  //comboboxState

  // modal
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    const abortController = new AbortController()
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(false, querySearchCondition, abortController.signal).finally(
          () => {
            dispatch(画面ロック解除())
          }
        )
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
    return () => {
      abortController.abort()
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `積卸先マスタ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">積卸先マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="input-group">
                              <TextInput
                                style={{ width: "6rem" }}
                                id="荷主コード"
                                name="荷主コード"
                                placeholder="荷主CD"
                                value={荷主コード}
                                maxLength={VALIDATE_CONSTANT.LENGTH.荷主コード}
                                setValue={(v) => {
                                  set荷主コード(v)
                                }}></TextInput>
                              <button
                                type="button"
                                className="icon-button"
                                onClick={() => {
                                  setIs荷主検索Modal(true)
                                }}>
                                <FontAwesomeIcon
                                  className="icon-button-inner"
                                  icon={faSearch}
                                />
                              </button>
                              <TextInput
                                style={{ width: "20rem" }}
                                id="荷主名"
                                name="荷主名"
                                placeholder="荷主名"
                                maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                                value={荷主名}
                                setValue={(v) => {
                                  set荷主名(v)
                                }}></TextInput>
                            </div>
                            <div className="input-group">
                              <TextInput
                                style={{ width: "7rem" }}
                                id="積卸先コード"
                                name="積卸先コード"
                                placeholder="積卸先CD"
                                value={積卸先コード}
                                maxLength={
                                  VALIDATE_CONSTANT.LENGTH.積卸先コード
                                }
                                setValue={(v) => {
                                  set積卸先コード(v)
                                }}></TextInput>
                              <TextInput
                                style={{ width: "20rem" }}
                                id="積卸先名"
                                name="積卸先名"
                                value={積卸先名}
                                setValue={set積卸先名}
                                maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                                placeholder="積卸先名"
                              />
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <TextInput
                              style={{ width: "12rem" }}
                              id="都道府県"
                              name="都道府県"
                              value={住所１}
                              setValue={set住所１}
                              maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                              placeholder="都道府県"
                            />
                            <TextInput
                              style={{ width: "12rem" }}
                              id="市区町村名"
                              name="市区町村名"
                              value={住所２}
                              setValue={set住所２}
                              maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                              placeholder="市区町村"
                            />
                            <span className={"align-middle"}>
                              <CheckInput
                                id="廃止"
                                type={"switch"}
                                label={"廃止した積卸先を表示する"}
                                setValue={(v) => set削除済み包含フラグ(v)}
                                value={削除済み包含フラグ}
                              />
                            </span>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search(false)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                            <Button
                              style={{ marginLeft: "2rem" }}
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索（最新更新順）
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <>
                    {!読取専用フラグ && (
                      <Link
                        to={
                          util.getMenuPath(
                            マスタ管理メニューコード.積卸先マスタ登録
                          )[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          新規追加
                        </Button>
                      </Link>
                    )}
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  align="center"
                  width={80}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TTumiorosisakiListGetRes>
                    ) => {
                      // 部所登録
                      const url = util.getMenuPath(
                        マスタ管理メニューコード.積卸先マスタ登録
                      )[1]

                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )

                            //TODO: 受け渡すパラメータ確定後修正
                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.積卸先ID.toString()
                              )
                            )
                          }}>
                          {!読取専用フラグ ? "編集" : "参照"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主コード"
                  width={80}
                  header="荷主CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主名"
                  width={300}
                  header="荷主名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積卸先コード"
                  width={100}
                  header="積卸先CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="積卸先名"
                  width={200}
                  header="積卸先名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="住所１"
                  width={120}
                  header="都道府県"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="住所２"
                  width={120}
                  header="市区町村"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="住所３"
                  header="町名番地"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="更新ユーザ氏名"
                  width={120}
                  header="最終更新者"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="最終更新日時"
                  format={"d"}
                  width={160}
                  header="最終更新日時"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="ファイルURL" header="客先台帳">
                  <wjrGrid.FlexGridCellTemplate
                    cellType={wjrGrid.CellTemplateType.Cell}
                    template={(
                      context: TWijmoCellTemplateContext<TTumiorosisakiListGetRes>
                    ) =>
                      context.item.ファイルURL != null ? (
                        <a
                          href={context.item.ファイルURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault()
                            const service = new ContentService()
                            service
                              .get(context.item.ファイルURL)
                              .then((blob) => {
                                saveAs(blob, context.item.ファイル名)
                              })
                              .catch((err) => dispatch(setAlerts(err)))
                          }}>
                          {context.item.ファイル名}
                        </a>
                      ) : (
                        <></>
                      )
                    }></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={120}
                  binding="電話番号"
                  header="電話番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={120}
                  binding="積卸先担当者"
                  header="積卸先担当者"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set荷主コード(荷主.荷主コード)
          set荷主名(荷主.荷主名)
        }}></NinusiSearchModal>
    </Container>
  )
}

export default MasterTumiorosisakiList
